// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductTags_container__PQEmU","button":"ProductTags_button__yeRpH"};